import { storeToRefs, type StoreGeneric } from 'pinia';

type StoreToRefs<T extends StoreGeneric> = ReturnType<typeof storeToRefs<T>>;

export const passStoreThroughComposableFactory = <T extends StoreGeneric>(store: T): T & StoreToRefs<T> => ({
  ...store,
  ...storeToRefs(store),
});
